'use client'

import { useEffect } from 'react'

type PWASetupProps = {
    lang: string
    toolSlug?: string
    toolName?: string
}

export default function PWASetup({ lang, toolSlug, toolName }: PWASetupProps) {
    useEffect(() => {
        // Manifest/apple-touch-icon/apple-mobile-web-app-* больше НЕ трогаем
        // здесь руками через document.head - это раньше конфликтовало с
        // React 19's собственным управлением <link>/<meta> тегами, которые
        // приходят из Metadata API (app/layout.tsx и generateMetadata
        // конкретных страниц): React мог в любой момент пере-вставить свою
        // версию тега независимо от того, что этот эффект уже поменял
        // вручную, из-за чего в <head> оказывались ДВА конфликтующих
        // <link rel="manifest"> и "Сохранить как приложение" вело себя
        // непредсказуемо. Теперь каждая страница (включая popup-режим
        // ?do=pop) сама объявляет нужный manifest/иконки через
        // generateMetadata - см. [category]/page.tsx и [tool]/page.tsx.

        // Регистрация Service Worker - регистрируем сразу, не ждем load
        if ('serviceWorker' in navigator) {
            // Проверяем, не зарегистрирован ли уже service worker
            navigator.serviceWorker.getRegistration('/').then((registration) => {
                if (!registration) {
                    // Регистрируем только если еще не зарегистрирован
                    navigator.serviceWorker.register('/sw.js')
                        .then((registration) => {
                            console.log('ServiceWorker registration successful with scope: ', registration.scope)
                        })
                        .catch((err) => {
                            console.log('ServiceWorker registration failed: ', err)
                        })
                } else {
                    console.log('ServiceWorker already registered with scope: ', registration.scope)
                    // Браузер сам проверяет обновление sw.js не чаще раза в сутки -
                    // форсируем проверку на каждой загрузке страницы, чтобы фиксы
                    // (как этот) доезжали до уже открытых вкладок быстрее.
                    registration.update().catch(() => {})
                }
            })
        }

        // Cleanup function
        return () => {
            // Cleanup при размонтировании (если нужно)
        }
        // Регистрация service worker не зависит от lang/toolSlug/toolName -
        // достаточно один раз при монтировании
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null
}

